export const SITE_WORKING_CONDITION_ACQUISITION_SENSORS_TABLE_FRENCH_LOCALE = {
  headers: {
    hwId: "Capteur Hw Id",
    csId: "Capteur Cs Id",
    name: "Nom de la pièce",
    serialNumber: "Numéro de série",
    installationDate: "Date d'installation",
    lastTemperatureDate: "Date de dernière remontée",
  },
  empty: "Aucun capteur",
};
